import * as angular from 'angular';
import { FourTermsAssignment } from './four-terms-assignment/four-terms-assignment.component';
import { GradPlanningMetricTransfer } from './grad-planning-metric/grad-planning-metric-transfer.component';
import { GradPlanningTransferStepperComponent } from './grad-planning-transfer-stepper.component';
import { InstructionsStepTransfer } from './instructions/instructions-transfer.component';
import { NotOnTarget } from './not-on-target/not-on-target.component';
import { OneTermAssignment } from './one-term-assignment/one-term-assignment.component';
import { OffTrack } from './review-off-track/review-off-track.component';
import { SafetyNetEligibleTransfer } from './safety-net-eligible/safety-net-eligible-transfer.component';
import { ThreeTermsAssignment } from './three-terms-assignment/three-terms-assignment.component';
import { TwoTermsAssignment } from './two-terms-assignment/two-terms-assignment.component';

export const GradPlanningTransferStepperModule = angular
  .module('gradPlanningTransferStepper', [])
  .component('gradPlanningTransferStepper', GradPlanningTransferStepperComponent)
  .component('instructionsStepTransfer', InstructionsStepTransfer)
  .component('gradPlanningMetricTransfer', GradPlanningMetricTransfer)
  .component('safetyNetEligibleTransfer', SafetyNetEligibleTransfer)
  .component('oneTermAssignment', OneTermAssignment)
  .component('twoTermsAssignment', TwoTermsAssignment)
  .component('threeTermsAssignment', ThreeTermsAssignment)
  .component('fourTermsAssignment', FourTermsAssignment)
  .component('offTrack', OffTrack)
  .component('notOnTarget', NotOnTarget).name;
